import React, { useEffect, useRef, useState } from 'react';
import { FaCheck, FaCopy } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';
import { buttonClass } from '../uiStyles';

/** Copy-to-clipboard button that confirms for two seconds, then resets. */
const CopyButton = ({ value, className = '' }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = async () => {
    if (!value) return;
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(value);
      } else {
        // Older browsers and pages served over plain http have no async clipboard.
        const area = document.createElement('textarea');
        area.value = value;
        area.setAttribute('readonly', '');
        area.style.position = 'absolute';
        area.style.left = '-9999px';
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        document.body.removeChild(area);
      }
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <button
      type="button"
      onClick={copy}
      disabled={!value}
      className={`${buttonClass(isDarkMode, copied ? 'primary' : 'secondary')} inline-flex items-center gap-2 ${className}`}
    >
      {copied ? <FaCheck /> : <FaCopy />}
      {copied ? t('useful.copied') : t('useful.copy')}
    </button>
  );
};

export default CopyButton;
